// GENERAL NUTRITION section.
//
// Merges the old LIFESTYLE NUTRITION + FOOD FACTS + UNDERSTANDING NUTRITION MYTHS
// content into one section. Asset sources:
//   - NEW cards (only in the 2026 design): 2026 General Nutrition folder + jpgs/.
//   - REORG cards (existed pre-redesign): now point at the updated 2026 PDFs, but
//     keep their existing (legacy) thumbnails — those docs have no 2026 jpg.
import { pdf2026, thumb2026, S3 } from "./assets";

// new 2026 General Nutrition card (2026 pdf + 2026 jpg)
const gn = (title, file, thumb, ext = "pdf") => ({
  title,
  pdf: pdf2026("General Nutrition", `${file}.${ext}`),
  thumb: thumb2026(`${thumb || file}.jpg`),
});
// reorg card: updated 2026 PDF + reused legacy thumbnail (full URL verbatim)
const reorg = (title, file, thumb) => ({
  title,
  pdf: pdf2026("General Nutrition", `${file}.pdf`),
  thumb,
});

const generalNutritionCards = [
  // Row 1
  reorg("Lifestyle Nutrition Guide", "Lifestyle Nutition Guide", `${S3}/pdf/LifeNutritionGudie.png`),
  gn("ACLM Guide: Benefits of Plant-Based Nutrition", "ACLM Guide Benefits of Plant-Based Nutrition"),
  gn("ACLM Guide: Food as Medicine", "ACLM Guide Food as Medicine", "ACLM Food As Medicine"),
  gn("Mindful Eating", "Mindful Eating"),
  // Row 2
  gn("Moving Toward a Whole Food, Plant-Based Diet", "Moving Toward a Whole Food, Plant-Based Diet"),
  reorg("Cost Comparison Guide", "Cost Comparison Guide", `${S3}/pdf/ComparingCost_LR.png`),
  gn("Healthy Foods Culture", "Healthy Foods Culture"),
  reorg("Common Nutrition Myths", "Common Nutrition Myths", `${S3}/pdf/Nutrition+Myth+2023_LR.png`),
  // Row 3
  reorg("Whole Food, Plant-Based Plate", "Whole Food, Plant-Based Plate", `${S3}/pdf/ACLM+Plate_LR.png`),
  reorg("Canada Plate Approach", "Canada Plate Approach", `${S3}/pdf/Canada+Plate_LR.png`),
  gn("The Nutrition Rainbow", "The Nutrition Rainbow"),
  reorg("Calorie Density", "Calorie Density", `${S3}/pdf/Calorie-Density_LR.png`),
  // Row 4
  gn("Understanding Ultra-Processed Foods (UPF)", "Understanding Ultra-Processed Foods (UPF)", "Understanding Ultra-Processed Foods (UPF)", "png"),
  gn("The Protein Myth", "The Protein Myth"),
  // Staying Hydrated PDF actually lives in the Managing Diabetes folder.
  { title: "Staying Hydrated", pdf: pdf2026("Managing Diabetes", "Staying Hydrated.pdf"), thumb: thumb2026("Staying Hydrated.jpg") },
  gn("Drinking More Water", "Drinking More Water"),
  // Row 5
  reorg("Superfoods", "Superfoods", `${S3}/pdf/Superfood+List+7_13_22_LR.png`),
  reorg("Plant vs. Animal Protein Sources", "Plant vs. Animal Protein Sources", `${S3}/pdf/Plant+vs.+Animal+Protein_LR.png`),
  gn("ACLM Guide: Comparing Protein Sources", "ACLM Guide Comparing Protein Sources"),
  reorg("Iron on a Vegan Diet", "Iron on a Vegan Diet", `${S3}/pdf/Vegan+iron+sources_LR.png`),
  // Row 6
  reorg("Calcium", "Calcium", `${S3}/pdf/Calcium.png`),
  reorg("Nourish Bowl", "Nourish Bowl", `${S3}/pdf/How+to+make+a+nourish+bowl_LR.png`),
  reorg("Plant-based Snacks and Recipes", "Plant-based Snacks and Recipes", `${S3}/pdf/Plant+based+snacks.png`),
  gn("Green Smoothie Guide", "Green Smoothie Guide"),
  // Row 7
  gn("Tips for Eating Healthy During Group Events", "Tips for Eating Healthy During Group Events"),
  { title: "Tips to Eat Healthier When Eating Out", pdf: pdf2026("General Nutrition", "Tips to Eat Healthier When Eating Out .pdf"), thumb: thumb2026("Tips to Eat Healthier When Eating Out -1.jpg") },
];

export default generalNutritionCards;
